import { render, staticRenderFns } from "./UserTasks.vue?vue&type=template&id=7fa38b43&scoped=true&"
import script from "./UserTasks.vue?vue&type=script&lang=js&"
export * from "./UserTasks.vue?vue&type=script&lang=js&"
import style0 from "./UserTasks.vue?vue&type=style&index=0&id=7fa38b43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa38b43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardActions,VCheckbox,VList,VListItem,VListItemTitle,VMenu,VSimpleTable})
